import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { http } from './http';

var PaymentService = /*#__PURE__*/function () {
  function PaymentService() {
    _classCallCheck(this, PaymentService);
  }

  _createClass(PaymentService, [{
    key: "getOrder",
    value: function () {
      var _getOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.get("/order/".concat(orderId));

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getOrder(_x) {
        return _getOrder.apply(this, arguments);
      }

      return getOrder;
    }()
  }, {
    key: "createSubscriptionOrder",
    value: function () {
      var _createSubscriptionOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(planId, body) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.post("/plan/".concat(planId, "/orders"), body);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function createSubscriptionOrder(_x2, _x3) {
        return _createSubscriptionOrder.apply(this, arguments);
      }

      return createSubscriptionOrder;
    }()
  }, {
    key: "initSubscriptionOrderPayment",
    value: function () {
      var _initSubscriptionOrderPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(planId, orderId, stripeCardToken) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http.put("/plan/".concat(planId, "/orders/").concat(orderId, "/init-payment"), {
                  stripeCardToken: stripeCardToken
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function initSubscriptionOrderPayment(_x4, _x5, _x6) {
        return _initSubscriptionOrderPayment.apply(this, arguments);
      }

      return initSubscriptionOrderPayment;
    }()
  }, {
    key: "createSessionOrder",
    value: function () {
      var _createSessionOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dto) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.post("/session/orders", dto);

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function createSessionOrder(_x7) {
        return _createSessionOrder.apply(this, arguments);
      }

      return createSessionOrder;
    }()
  }, {
    key: "initSessionOrderPayment",
    value: function () {
      var _initSessionOrderPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sessionId, orderId, stripeCardToken) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return http.put("/session/".concat(sessionId, "/orders/").concat(orderId, "/init-payment"), {
                  stripeCardToken: stripeCardToken
                });

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", result.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function initSessionOrderPayment(_x8, _x9, _x10) {
        return _initSessionOrderPayment.apply(this, arguments);
      }

      return initSessionOrderPayment;
    }()
  }, {
    key: "updateOrder",
    value: function () {
      var _updateOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(orderId, dto) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return http.put("/order/".concat(orderId), dto);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function updateOrder(_x11, _x12) {
        return _updateOrder.apply(this, arguments);
      }

      return updateOrder;
    }()
  }, {
    key: "checkPromoCode",
    value: function () {
      var _checkPromoCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orderId, promoCode) {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return http.get("/order/".concat(orderId, "/check-promo-code?promoCode=").concat(encodeURIComponent(promoCode)));

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", result.data);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function checkPromoCode(_x13, _x14) {
        return _checkPromoCode.apply(this, arguments);
      }

      return checkPromoCode;
    }()
  }, {
    key: "createPaymentSource",
    value: function () {
      var _createPaymentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(userId, source) {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return http.post("/user/".concat(userId, "/payment-sources"), {
                  source: source
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", result.data);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function createPaymentSource(_x15, _x16) {
        return _createPaymentSource.apply(this, arguments);
      }

      return createPaymentSource;
    }()
  }, {
    key: "getPaymentSources",
    value: function () {
      var _getPaymentSources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(userId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return http.get("/user/".concat(userId, "/payment-sources"));

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", result.data);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getPaymentSources(_x17) {
        return _getPaymentSources.apply(this, arguments);
      }

      return getPaymentSources;
    }()
  }, {
    key: "deletePaymentSource",
    value: function () {
      var _deletePaymentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(userId, sourceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return http.post("/user/".concat(userId, "/delete-payment-source"), {
                  sourceId: sourceId
                });

              case 2:
                result = _context10.sent;
                return _context10.abrupt("return", result.data);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function deletePaymentSource(_x18, _x19) {
        return _deletePaymentSource.apply(this, arguments);
      }

      return deletePaymentSource;
    }()
  }]);

  return PaymentService;
}();

var paymentService = new PaymentService();
export default paymentService;